/** localStorage key — only the JWT/auth string is persisted (no user or workshop profile). */
export const AUTH_TOKEN_KEY = 'auth';

export function readStoredAuthToken() {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const value = window.localStorage.getItem(AUTH_TOKEN_KEY);
    return value?.trim() || null;
  } catch {
    return null;
  }
}

export function writeStoredAuthToken(token) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(AUTH_TOKEN_KEY, token.trim());
  } catch {
    /* quota / private mode */
  }
}

export function clearStoredAuthToken() {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.removeItem(AUTH_TOKEN_KEY);
    // Legacy key from earlier landing-page auth — remove on sign-out.
    window.localStorage.removeItem('garaaz_auth_phone');
  } catch {
    /* ignore */
  }
}
